import React, { Component, Fragment } from 'react';
import genericImage from '../../assets/castle-9291010_1280.jpg';
import './SpaceComponent.css';

interface SpaceComponentProps {
  spaceID: string;
  name: string;
  location: string;
  photoUrl?: string;
  reserveSpace: (spaceId: string) => void;
}

export class SpaceComponent extends Component<SpaceComponentProps> {
  private renderImage() {
    if (this.props.photoUrl) {
      return <img className="spaceImage" src={this.props.photoUrl} alt=" " />;
    } else {
      return (
        <img
          className="spaceImage"
          src={genericImage}
          alt="Castle Fortress Mystical royalty-free stock illustration"
          title="Image by FriedeDia from Pixabay"
        />
      );
    }
  }
  render() {
    return (
      <div className="spaceComponent">
        {this.renderImage()}
        <label>{this.props.name}</label>
        <label>{this.props.spaceID}</label>
        <label>{this.props.location}</label>
        <button onClick={() => this.props.reserveSpace(this.props.spaceID)}>
          Reserve
        </button>
      </div>
    );
  }
}
